import * as React from 'react';
type Props = {
  className?: string;
};
export function Check({ className }: Props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="utility-check"
      className={className}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.435 6.70709L19.8492 8.12131L12.0711 15.8995L10.6569 17.3137L5 11.6568L6.41421 10.2426L10.657 14.4851L18.435 6.70709Z"
        fill="currentColor"
      />
    </svg>
  );
}
